import styled from "styled-components";
import { Card } from 'antd';
const isMobile = window.innerWidth < 768;

export const StyledCarousel = styled.div<{
  isTablet?: boolean;
  isXs?: any;
}>`

    .embla {
        margin: auto;
        --slide-height: 19rem;
        --slide-spacing: 1rem;
        --slide-size: ${({ isXs, isTablet }) =>
      isXs ? '92%' : isTablet ? '33%' : '20%'};
    }
    .embla__viewport {
        overflow: hidden;
        height: 450px;
    }
    .embla__container {
        display: flex;
        touch-action: pan-y pinch-zoom;
        margin-left: calc(var(--slide-spacing) * -1);
    }
    .embla__slide {
        transform: translate3d(0, 0, 0);
        flex: 0 0 var(--slide-size);
        min-width: 0;
        padding-left: var(--slide-spacing);
    }
    .embla__slide__number {
        box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
        border-radius: 1.8rem;
        font-size: 4rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        height: var(--slide-height);
        user-select: none;
    }
    .embla__controls {
        display: grid;
        grid-template-columns: auto;
        justify-content: center;
        gap: 1.2rem;
        margin-top: 1.8rem;
    }

    .embla__dots {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
        margin-right: calc((2.6rem - 1.4rem) / 2 * -1);
        gap: 8px;
    }
    .embla__dot {
        appearance: none;
        background-color: transparent;
        touch-action: manipulation;
        display: inline-flex;
        text-decoration: none;
        cursor: pointer;
        border: 0;
        padding: 0;
        margin: 0;
        width: 8px;
        height: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
    }
    .embla__dot:after {
        border: none;
        background-color: rgba(98, 108, 112, 0.5);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        content: '';
    }
    .embla__dot--selected:after {
        background-color: rgba(35, 139, 255, 1);
    }

`

export const MyCard = styled(Card)`
  .ant-card-body {
    height: 100%;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;